// extracted by mini-css-extract-plugin
export var card = "_4m-0";
export var content = "_4m-1";
export var contentLoading = "_4m-2";